import { extend } from 'vee-validate';
// use UMD export because regular import breaks tests (lack of transpilation)
const { required } = require('vee-validate/dist/rules.umd.js');
/**
 * legacy extended vee-validate v3 global rules
 * these should be removed when no forms in the application require these rules
 */
extend('required', {
    ...required,
    message: '{_field_} is required'
});
